"use strict";
// const resistance = will <= 0 ? 0
// : will / 2000 * Math.log(will) / Math.log(1.25);
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateLevelScaledLog = void 0;
const Round_1 = require("../core/utils/Round");
function calculateLevelScaledLog(level, value) {
    // https://www.wolframalpha.com/input/?i=plot+x+%2F+%28y+*+100%29+*+log%28x%29+%2F+log%281.25%29+for+x+from+0+to+5000+and+y+from+1+to+50
    if (value < 1 || level < 1) {
        return 0;
    }
    const next = value / (level * 100) * Math.log(value) / Math.log(1 + value / (level * 250));
    return (0, Round_1.roundTo)(next, 2);
}
exports.calculateLevelScaledLog = calculateLevelScaledLog;
